import { render, staticRenderFns } from "./ShipbluPagination.vue?vue&type=template&id=6dcb0ffe"
import script from "./ShipbluPagination.vue?vue&type=script&lang=js"
export * from "./ShipbluPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports